import { render, staticRenderFns } from "./FscCardHeader.vue?vue&type=template&id=608e436a"
import script from "./FscCardHeader.vue?vue&type=script&lang=ts"
export * from "./FscCardHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports